import React from "react";
import { Alert } from "antd";

const ShipmentEtaCalendarFooter = ({ type, restrictedDatesString }) => {
  return (
    <Alert
      message={
        <div>
          Not available for {type} on: <br /> <strong>{restrictedDatesString}</strong>
        </div>
      }
      type="info"
      showIcon
      style={{ width: "100%", marginTop: 5, marginBottom: 5 }}
    />
  );
};

export default ShipmentEtaCalendarFooter;
